import { useCallback, useEffect, useState } from "react";
import { deleteData, fetchData, getAccessToken, postData, putData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";

export default function ReportYearlyAll() {
    const { instance, accounts } = useMsal();
    const { year } = useParams();
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        //get years for the Receipts
        getAccessToken(instance, accounts).then(response => {
            fetchData(response, `/yearly_all_with_contribution_report/${year}`, res => {
                if (!res.ok)
                    throw new Error(`HTTP error! status: ${res.status}`);

                return res.json();
            }, data => {
                setReportData(data);
            })
        })
    }, [instance, accounts])

    if (!year || year.trim() === '') {
        return <div>Please specify a year in the URL (e.g., /ReportYearlyAll/2022)</div>;
    }

    return (
        <div>
            <h1>Yearly Report for {year}</h1>
            {reportData ? (
                <>
                    <div className="d-flex justify-content-between">
                        <h3>Total Count: {reportData.length}</h3>
                        <h3>Total Contribution: ${reportData.reduce((sum, item) => sum + item.TotalYearlyAmount, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                    </div>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Member ID</th>
                                <th>Call Name</th>
                                <th>Saint Name</th>
                                <th>Last Name</th>
                                <th>Middle Name</th>
                                <th>First Name</th>
                                <th>HNDOG Spouse Name</th>
                                <th>Chi hoi</th>
                                <th>HNDOG Cancelation</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Postal Code</th>
                                <th>Country</th>
                                <th>Home Phone</th>
                                <th>Work Phone</th>
                                <th>Mobile Phone</th>
                                <th>Fax</th>
                                <th>Email</th>
                                <th>Return to Sender</th>
                                <th>Note</th>
                                <th>Receipt ?</th>
                                <th>Receipt's Name</th>
                                <th>Receipt's Adress</th>
                                <th>Receipts' City</th>
                                <th>Receipt's State</th>
                                <th>Receipt's Postal Code</th>
                                <th>Receipt's Country</th>
                                <th>Receipt's Phone</th>
                                <th>Receipt_Mark</th>
                                <th>HNDOG PLTT Mark</th>
                                <th>HNDOG PLTT Date</th>
                                <th>HNDOG PLTT Note</th>
                                <th>HNDOG Flag</th>
                                <th>HNDOG PLTT</th>
                                <th>Archive</th>
                                <th>Address not OK</th>
                                <th>Qua Doi</th>
                                <th>Ngay Qua Doi</th>
                                <th>Ngay Qua Doi2</th>
                                <th>Ten Qua Doi</th>
                                <th>Ten Qua Doi2</th>
                                <th>TotalYearlyAmount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.MemberID || '-'}</td>
                                    <td>{item.CallName || '-'}</td>
                                    <td>{item.SaintName || '-'}</td>
                                    <td>{item.LastName || '-'}</td>
                                    <td>{item.MiddleName || '-'}</td>
                                    <td>{item.FirstName || '-'}</td>
                                    <td>{item.HNDOG_SpouseName || '-'}</td>
                                    <td>{item.ChiHoi || '-'}</td>
                                    <td>{item.HNDOG_Cancelation ? 'Yes' : 'No'}</td>
                                    <td>{item.Address || '-'}</td>
                                    <td>{item.City || '-'}</td>
                                    <td>{item.State || '-'}</td>
                                    <td>{item.PostalCode || '-'}</td>
                                    <td>{item.Country || '-'}</td>
                                    <td>{item.HomePhone || '-'}</td>
                                    <td>{item.WorkPhone || '-'}</td>
                                    <td>{item.MobilePhone || '-'}</td>
                                    <td>{item.Fax || '-'}</td>
                                    <td>{item.Email || '-'}</td>
                                    <td>{item.ReturnToSender ? 'Yes' : 'No'}</td>
                                    <td>{item.Note || '-'}</td>
                                    <td>{item.Receipt ? 'Yes' : 'No'}</td>
                                    <td>{item.ReceiptName || '-'}</td>
                                    <td>{item.ReceiptAddress || '-'}</td>
                                    <td>{item.ReceiptCity || '-'}</td>
                                    <td>{item.ReceiptState || '-'}</td>
                                    <td>{item.ReceiptPostalCode || '-'}</td>
                                    <td>{item.ReceiptCountry || '-'}</td>
                                    <td>{item.ReceiptPhone || '-'}</td>
                                    <td>{item.ReceiptMark ? 'Yes' : 'No'}</td>
                                    <td>{item.HNDOG_PLTT_Mark ? 'Yes' : 'No'}</td>
                                    <td>{item.HNDOG_PLTT_Date || '-'}</td>
                                    <td>{item.HNDOG_PLTT_Note || '-'}</td>
                                    <td>{item.HNDOG_Flag ? 'Yes' : 'No'}</td>
                                    <td>{item.HNDOG_PLTT || '-'}</td>
                                    <td>{item.Archive ? 'Yes' : 'No'}</td>
                                    <td>{item.AddressInvalid ? 'Yes' : 'No'}</td>
                                    <td>{item.QuaDoi ? 'Yes' : 'No'}</td>
                                    <td>{item.NgayQuaDoi || '-'}</td>
                                    <td>{item.NgayQuaDoiSpouse || '-'}</td>
                                    <td>{item.TenQuaDoi || '-'}</td>
                                    <td>{item.TenQuaDoiSpouse || '-'}</td>
                                    <td>${item.TotalYearlyAmount || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <h3>Total Count: {reportData.length}</h3>
                        <h3>Total Contribution: ${reportData.reduce((sum, item) => sum + item.TotalYearlyAmount, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                    </div>
                </>
            ) : (
                <p>Loading report data...</p>
            )}
        </div>
    );
}